var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcClose") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.7178258,572.420026 L80.6112072,568.52664 C80.9695976,568.168249 80.9695976,567.587184 80.6112072,567.228844 C80.2528167,566.870454 79.6718038,566.870454 79.3134134,567.228844 L75.4199808,571.122282 L71.5265482,567.228793 C71.1681577,566.870402 70.5871448,566.870402 70.2287544,567.228793 C69.8704152,567.587184 69.8704152,568.168249 70.2287544,568.526588 L74.122187,572.419974 L70.2287544,576.313412 C69.8704152,576.671802 69.8704152,577.252867 70.2287544,577.611207 C70.5871448,577.969598 71.1681577,577.969598 71.5265482,577.611207 L75.4199808,573.71777 L79.3134134,577.611207 C79.6717526,577.969598 80.2528167,577.969598 80.6112072,577.611207 C80.9695976,577.252816 80.9695976,576.671802 80.6112072,576.313412 L76.7178258,572.420026 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover-Copy-3",
    transform: "translate(-69.000000, -567.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "onboardingIcClose",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcClose);
export default __webpack_public_path__ + "static/media/onboardingIcClose.efed434e285b8280fe764c29f4dafa25.svg";
export { ForwardRef as ReactComponent };